<div class="dashboard-section">
  <core-title-section
    [title]="'DASHBOARD'"
  ></core-title-section>

  <article  class="dashboard-main">
    <app-helpers-search-bar-main
      [placeholder]="'Search the dashboard'"
      [term]="term"
      [filters]="appliedFilters"
      (termChanges)="onSetTerm($event)"
      (removeFilter)="onRemove($event)"
    ></app-helpers-search-bar-main>

    <dashboard-search-filters></dashboard-search-filters>
  </article>
</div >

